import {KTCard, KTCardBody} from '../../../../_websoft/helpers'
import {ToastContainer} from 'react-toastify'
import React from 'react'

const Repromaterijali: React.FC = () => {
    return (
        <KTCard>
            <ToastContainer />
            <KTCardBody className='py-4'>
                <div className='container-fluid px-0 px-md-3'>
                    {/* Header */}
                    <div className='d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-2 mb-4'>
                        <div>
                            <h2 className='fw-bolder text-gray-900 mb-1'>Repromaterijali</h2>
                            <div className='text-muted'>Odaberi modul koji želiš otvoriti.</div>
                        </div>
                    </div>

                    {/* Grid */}
                    <div className='row g-4'>
                        {/* Lista rolni */}
                        <div className='col-12 col-md-6 col-xl-4'>
                            <a
                                href='repromaterijali/lista'
                                className='card bg-black hoverable shadow-sm border-0 h-100'
                                style={{textDecoration: 'none'}}
                            >
                                <div className='card-body d-flex align-items-center justify-content-between p-4 p-md-5'>
                                    <div className='d-flex align-items-center gap-4'>
                                        <div
                                            className='rounded-circle d-flex align-items-center justify-content-center'
                                            style={{width: 56, height: 56, background: 'rgba(255,255,255,0.14)'}}
                                        >
                                            <i className='ki-duotone ki-element-11 text-white fs-2x'>
                                                <span className='path1' />
                                                <span className='path2' />
                                                <span className='path3' />
                                                <span className='path4' />
                                            </i>
                                        </div>
                                        <div>
                                            <div className='text-white fw-bolder fs-2'>Lista rolni</div>
                                            <div className='text-white opacity-75 mt-1'>Pregled svih rolni i detalja.</div>
                                        </div>
                                    </div>
                                    <i className='bi bi-chevron-right text-white fs-2 opacity-75' />
                                </div>
                            </a>
                        </div>

                        {/* Rolne u dolasku */}
                        <div className='col-12 col-md-6 col-xl-4'>
                            <a
                                href='repromaterijali/rolne-u-dolasku'
                                className='card bg-black hoverable shadow-sm border-0 h-100'
                                style={{textDecoration: 'none'}}
                            >
                                <div className='card-body d-flex align-items-center justify-content-between p-4 p-md-5'>
                                    <div className='d-flex align-items-center gap-4'>
                                        <div
                                            className='rounded-circle d-flex align-items-center justify-content-center'
                                            style={{width: 56, height: 56, background: 'rgba(255,255,255,0.14)'}}
                                        >
                                            <i className='ki-duotone ki-element-11 text-white fs-2x'>
                                                <span className='path1' />
                                                <span className='path2' />
                                                <span className='path3' />
                                                <span className='path4' />
                                            </i>
                                        </div>
                                        <div>
                                            <div className='text-white fw-bolder fs-2'>Rolne u dolasku</div>
                                            <div className='text-white opacity-75 mt-1'>Najave i evidencija dolazaka.</div>
                                        </div>
                                    </div>
                                    <i className='bi bi-chevron-right text-white fs-2 opacity-75' />
                                </div>
                            </a>
                        </div>

                        {/* Promet rolne */}
                       {/* <div className='col-12 col-md-6 col-xl-4'>
                            <a
                                href='repromaterijali/promet'
                                className='card bg-black hoverable shadow-sm border-0 h-100'
                                style={{textDecoration: 'none'}}
                            >
                                <div className='card-body d-flex align-items-center justify-content-between p-4 p-md-5'>
                                    <div className='d-flex align-items-center gap-4'>
                                        <div
                                            className='rounded-circle d-flex align-items-center justify-content-center'
                                            style={{width: 56, height: 56, background: 'rgba(255,255,255,0.14)'}}
                                        >
                                            <i className='ki-duotone ki-element-11 text-white fs-2x'>
                                                <span className='path1' />
                                                <span className='path2' />
                                                <span className='path3' />
                                                <span className='path4' />
                                            </i>
                                        </div>
                                        <div>
                                            <div className='text-white fw-bolder fs-2'>Promet rolne</div>
                                            <div className='text-white opacity-75 mt-1'>Kreiranje i pregled prometa.</div>
                                        </div>
                                    </div>
                                    <i className='bi bi-chevron-right text-white fs-2 opacity-75' />
                                </div>
                            </a>
                        </div>*/}

                        {/* Izmijeni status / lokaciju */}
                        <div className='col-12 col-md-6 col-xl-4'>
                            <a
                                href='repromaterijali/izmjena-lokacije'
                                className='card bg-black hoverable shadow-sm border-0 h-100'
                                style={{textDecoration: 'none'}}
                            >
                                <div className='card-body d-flex align-items-center justify-content-between p-4 p-md-5'>
                                    <div className='d-flex align-items-center gap-4'>
                                        <div
                                            className='rounded-circle d-flex align-items-center justify-content-center'
                                            style={{width: 56, height: 56, background: 'rgba(255,255,255,0.18)'}}
                                        >
                                            <i className='ki-duotone ki-element-11 text-white fs-2x'>
                                                <span className='path1' />
                                                <span className='path2' />
                                                <span className='path3' />
                                                <span className='path4' />
                                            </i>
                                        </div>
                                        <div>
                                            <div className='text-white fw-bolder fs-2'>Status / lokacija</div>
                                            <div className='text-white opacity-75 mt-1'>Brza izmjena stanja rolne.</div>
                                        </div>
                                    </div>
                                    <i className='bi bi-chevron-right text-white fs-2 opacity-75' />
                                </div>
                            </a>
                        </div>

                        {/* Prijavi grešku rolne */}
                        <div className='col-12 col-md-6 col-xl-4'>
                            <a
                                href='repromaterijali/prijavi-gresku'
                                className='card bg-primary hoverable shadow-sm border-0 h-100'
                                style={{textDecoration: 'none'}}
                            >
                                <div className='card-body d-flex align-items-center justify-content-between p-4 p-md-5'>
                                    <div className='d-flex align-items-center gap-4'>
                                        <div
                                            className='rounded-circle d-flex align-items-center justify-content-center'
                                            style={{width: 56, height: 56, background: 'rgba(255,255,255,0.18)'}}
                                        >
                                            <i className='ki-duotone ki-element-11 text-white fs-2x'>
                                                <span className='path1' />
                                                <span className='path2' />
                                                <span className='path3' />
                                                <span className='path4' />
                                            </i>
                                        </div>
                                        <div>
                                            <div className='text-white fw-bolder fs-2'>Prijavi grešku</div>
                                            <div className='text-white opacity-75 mt-1'>Evidencija grešaka i napomena.</div>
                                        </div>
                                    </div>
                                    <i className='bi bi-chevron-right text-white fs-2 opacity-75' />
                                </div>
                            </a>
                        </div>

                        {/* Kartica rolne */}
                        <div className='col-12 col-md-6 col-xl-4'>
                            <a
                                href='repromaterijali/kartica-rolne'
                                className='card bg-black hoverable shadow-sm border-0 h-100'
                                style={{textDecoration: 'none'}}
                            >
                                <div className='card-body d-flex align-items-center justify-content-between p-4 p-md-5'>
                                    <div className='d-flex align-items-center gap-4'>
                                        <div
                                            className='rounded-circle d-flex align-items-center justify-content-center'
                                            style={{width: 56, height: 56, background: 'rgba(255,255,255,0.14)'}}
                                        >
                                            <i className='ki-duotone ki-element-11 text-white fs-2x'>
                                                <span className='path1' />
                                                <span className='path2' />
                                                <span className='path3' />
                                                <span className='path4' />
                                            </i>
                                        </div>
                                        <div>
                                            <div className='text-white fw-bolder fs-2'>Kartica rolne</div>
                                            <div className='text-white opacity-75 mt-1'>Prikaz kartice i historije rolne.</div>
                                        </div>
                                    </div>
                                    <i className='bi bi-chevron-right text-white fs-2 opacity-75' />
                                </div>
                            </a>
                        </div>


                        {/* Inventura rolni */}
                        <div className='col-12 col-md-6 col-xl-4'>
                            <a
                                href='repromaterijali/inventura-rolni'
                                className='card bg-success hoverable shadow-sm border-0 h-100'
                                style={{textDecoration: 'none'}}
                            >
                                <div className='card-body d-flex align-items-center justify-content-between p-4 p-md-5'>
                                    <div className='d-flex align-items-center gap-4'>
                                        <div
                                            className='rounded-circle d-flex align-items-center justify-content-center'
                                            style={{width: 56, height: 56, background: 'rgba(255,255,255,0.18)'}}
                                        >
                                            <i className='ki-duotone ki-element-11 text-white fs-2x'>
                                                <span className='path1' />
                                                <span className='path2' />
                                                <span className='path3' />
                                                <span className='path4' />
                                            </i>
                                        </div>
                                        <div>
                                            <div className='text-white fw-bolder fs-2'>Inventura rolni</div>
                                            <div className='text-white opacity-75 mt-1'>Unos i kontrola inventure rolni.</div>
                                        </div>
                                    </div>
                                    <i className='bi bi-chevron-right text-white fs-2 opacity-75' />
                                </div>
                            </a>
                        </div>

                        {/* Inventura traka */}
                        <div className='col-12 col-md-6 col-xl-4'>
                            <a
                                href='repromaterijali/inventura-traka'
                                className='card bg-danger hoverable shadow-sm border-0 h-100'
                                style={{textDecoration: 'none'}}
                            >
                                <div className='card-body d-flex align-items-center justify-content-between p-4 p-md-5'>
                                    <div className='d-flex align-items-center gap-4'>
                                        <div
                                            className='rounded-circle d-flex align-items-center justify-content-center'
                                            style={{width: 56, height: 56, background: 'rgba(255,255,255,0.18)'}}
                                        >
                                            <i className='ki-duotone ki-element-11 text-white fs-2x'>
                                                <span className='path1' />
                                                <span className='path2' />
                                                <span className='path3' />
                                                <span className='path4' />
                                            </i>
                                        </div>
                                        <div>
                                            <div className='text-white fw-bolder fs-2'>Inventura traka</div>
                                            <div className='text-white opacity-75 mt-1'>Unos i kontrola inventure traka.</div>
                                        </div>
                                    </div>
                                    <i className='bi bi-chevron-right text-white fs-2 opacity-75' />
                                </div>
                            </a>
                        </div>

                        {/* Qr kod kartica */}
                        <div className='col-12 col-md-6 col-xl-4'>
                            <a
                                href='repromaterijali/qr-kod-kartice'
                                className='card bg-black hoverable shadow-sm border-0 h-100'
                                style={{textDecoration: 'none'}}
                            >
                                <div className='card-body d-flex align-items-center justify-content-between p-4 p-md-5'>
                                    <div className='d-flex align-items-center gap-4'>
                                        <div
                                            className='rounded-circle d-flex align-items-center justify-content-center'
                                            style={{width: 56, height: 56, background: 'rgba(255,255,255,0.14)'}}
                                        >
                                            <i className='ki-duotone ki-element-11 text-white fs-2x'>
                                                <span className='path1' />
                                                <span className='path2' />
                                                <span className='path3' />
                                                <span className='path4' />
                                            </i>
                                        </div>
                                        <div>
                                            <div className='text-white fw-bolder fs-2'>QR kod kartica</div>
                                            <div className='text-white opacity-75 mt-1'>Generiši i ispiši QR kartice.</div>
                                        </div>
                                    </div>
                                    <i className='bi bi-chevron-right text-white fs-2 opacity-75' />
                                </div>
                            </a>
                        </div>

                        {/* Divider */}
                        <div className='col-12'>
                            <div className='separator my-2' />
                        </div>

                        {/* Promet trake */}
                        <div className='col-12 col-md-6 col-xl-4'>
                            <a
                                href='repromaterijali/promet-trake'
                                className='card bg-primary hoverable shadow-sm border-0 h-100'
                                style={{textDecoration: 'none'}}
                            >
                                <div className='card-body d-flex align-items-center justify-content-between p-4 p-md-5'>
                                    <div className='d-flex align-items-center gap-4'>
                                        <div
                                            className='rounded-circle d-flex align-items-center justify-content-center'
                                            style={{width: 56, height: 56, background: 'rgba(255,255,255,0.18)'}}
                                        >
                                            <i className='ki-duotone ki-element-11 text-white fs-2x'>
                                                <span className='path1' />
                                                <span className='path2' />
                                                <span className='path3' />
                                                <span className='path4' />
                                            </i>
                                        </div>
                                        <div>
                                            <div className='text-white fw-bolder fs-2'>Promet trake</div>
                                            <div className='text-white opacity-75 mt-1'>Kreiranje prometa trake.</div>
                                        </div>
                                    </div>
                                    <i className='bi bi-chevron-right text-white fs-2 opacity-75' />
                                </div>
                            </a>
                        </div>

                        {/* Izmjeni lokaciju i status trake */}
                        <div className='col-12 col-md-6 col-xl-4'>
                            <a
                                href='repromaterijali/izmjena-trake'
                                className='card bg-black hoverable shadow-sm border-0 h-100'
                                style={{textDecoration: 'none'}}
                            >
                                <div className='card-body d-flex align-items-center justify-content-between p-4 p-md-5'>
                                    <div className='d-flex align-items-center gap-4'>
                                        <div
                                            className='rounded-circle d-flex align-items-center justify-content-center'
                                            style={{width: 56, height: 56, background: 'rgba(255,255,255,0.18)'}}
                                        >
                                            <i className='ki-duotone ki-element-11 text-white fs-2x'>
                                                <span className='path1' />
                                                <span className='path2' />
                                                <span className='path3' />
                                                <span className='path4' />
                                            </i>
                                        </div>
                                        <div>
                                            <div className='text-white fw-bolder fs-2'>Izmjena trake</div>
                                            <div className='text-white opacity-75 mt-1'>Promijeni lokaciju i status trake.</div>
                                        </div>
                                    </div>
                                    <i className='bi bi-chevron-right text-white fs-2 opacity-75' />
                                </div>
                            </a>
                        </div>

                        {/* Izmjeni lokaciju i status trake */}
                        <div className='col-12 col-md-6 col-xl-4'>
                            <a
                                href='repromaterijali/promet-prodaja'
                                className='card bg-primary hoverable shadow-sm border-0 h-100'
                                style={{textDecoration: 'none'}}
                            >
                                <div className='card-body d-flex align-items-center justify-content-between p-4 p-md-5'>
                                    <div className='d-flex align-items-center gap-4'>
                                        <div
                                            className='rounded-circle d-flex align-items-center justify-content-center'
                                            style={{width: 56, height: 56, background: 'rgba(255,255,255,0.18)'}}
                                        >
                                            <i className='ki-duotone ki-element-11 text-white fs-2x'>
                                                <span className='path1' />
                                                <span className='path2' />
                                                <span className='path3' />
                                                <span className='path4' />
                                            </i>
                                        </div>
                                        <div>
                                            <div className='text-white fw-bolder fs-2'>Promet rolne</div>
                                            <div className='text-white opacity-75 mt-1'>Direktna prodaja rolne</div>
                                        </div>
                                    </div>
                                    <i className='bi bi-chevron-right text-white fs-2 opacity-75' />
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </KTCardBody>
        </KTCard>
    )
}

export default Repromaterijali
